export default __webpack_public_path__ + "static/media/fsiRealCase2-sc.7eab1b08.jpg";